import { PATHS } from 'AppConstants';
export const PartnerHeading = 'Trusted by <br/> <span style="color: #ff664b">50,000+</span> Business Partners';
export const NavigationLinks = [
	{
		text: 'Why Mybiz?',
		type: 'whyBiz',
		link: '',
		trackVal: '',
		pageurl: PATHS.RESOURCE_PAGE
	},
	{
		text: 'Benefits',
		type: 'ben',
		link: 'Benefits',
		trackVal: '',
		pageurl: PATHS.RESOURCE_PAGE
	},
	{
		text: 'Case Studies',
		type: 'case',
		link: 'CaseStudies',
		trackVal: '',
		pageurl: PATHS.RESOURCE_PAGE
	}
];

export const partnerLogosData1 = [
	{
		width: '230px',
		logo: 'logoBridgestone'
	},
	{
		width: '116px',
		logo: 'logoBlackberry'
	},
	{
		width: '146px',
		logo: 'logoBiba'
	},
	{
		width: '139px',
		logo: 'logoBajajFinserv'
	},
	{
		width: '108px',
		logo: 'logoIffco'
	},
	{
		width: '158px',
		logo: 'logoBajajConsumer'
	},
	{
		width: '174px',
		logo: 'logoAkzoNobel'
	},
	{
		width: '151px',
		logo: 'logoNetflix'
	},
	{
		width: '122px',
		logo: 'logoManyavar'
	}
];

export const partnerLogosData2 = [
	{
		width: '72px',
		logo: 'logoBurgerKing'
	},
	{
		width: '38px',
		logo: 'logoLodha'
	},
	{
		width: '157px',
		logo: 'logoLalPathLabs'
	},
	{
		width: '142px',
		logo: 'logoJockey'
	},
	{
		width: '95px',
		logo: 'logoIsc'
	},
	{
		width: '142px',
		logo: 'logoInfoEdge'
	},
	{
		width: '98px',
		logo: 'logoGodrej'
	},
	{
		width: '174px',
		logo: 'logoExtraMarks'
	},
	{
		width: '151px',
		logo: 'logoByjus'
	},
	{
		width: '122px',
		logo: 'logoZomato'
	}
];

export const partnerLogosData3 = [
	{
		width: '112px',
		logo: 'logoTeamComputers'
	},
	{
		width: '118px',
		logo: 'logoStorz'
	},
	{
		width: '170px',
		logo: 'logoVidalHealth'
	},
	{
		width: '168px',
		logo: 'logoSbiCard'
	},
	{
		width: '154px',
		logo: 'logoRailVikas'
	},
	{
		width: '118px',
		logo: 'logoApollo'
	},
	{
		width: '128px',
		logo: 'logoPnBHousing'
	},
	{
		width: '120px',
		logo: 'logoPaySense'
	},
	{
		width: '100px',
		logo: 'logoCentaur'
	},
	{
		width: '90',
		logo: 'logoAcko'
	}
];

export const partnerLogosData4 = [
	{
		width: '295px',
		logo: 'logoHarsco'
	},
	{
		width: '147px',
		logo: 'logoTechMahindra'
	},
	{
		width: '104px',
		logo: 'logoTroikaa'
	},
	{
		width: '122px',
		logo: 'logoSleepwell'
	},
	{
		width: '109px',
		logo: 'logoRoyalCanin'
	},
	{
		width: '138px',
		logo: 'logoPonPure'
	},
	{
		width: '121px',
		logo: 'logoNandos'
	},
	{
		width: '102px',
		logo: 'logoNahar'
	},
	{
		width: '103px',
		logo: 'logoNaaptol'
	},
	{
		width: '103px',
		logo: 'logoRazorpay'
	}
];

export const partnerLogosData5 = [
	{
		width: '80px',
		logo: 'logoMuthoot'
	},
	{
		width: '116px',
		logo: 'logoMetropolis'
	},
	{
		width: '84px',
		logo: 'logoMcDonalds'
	},
	{
		width: '106px',
		logo: 'logoFleetGuard'
	},
	{
		width: '112px',
		logo: 'logoEverest'
	},
	{
		width: '100px',
		logo: 'logoCremica'
	},
	{
		width: '189px',
		logo: 'logoColorJet'
	},
	{
		width: '102px',
		logo: 'logoNahar'
	},
	{
		width: '94px',
		logo: 'logoCera'
	},
	{
		width: '154px',
		logo: 'logoLifeCell'
	},
	{
		width: '122px',
		logo: 'logoMalabar'
	}

];
